// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__170C0","colMaxWidth":"Table_colMaxWidth__1FSNX"};